import React, { FC } from 'react';
import Utils from '../../utils/Utils';
import { Typography } from 'antd';
import './InfoViewStyle.less';

const { Title } = Typography;
type Props = {
  title: string;
  fullwidth?: boolean;
};

export const InfoView: FC<React.HTMLAttributes<HTMLDivElement>> = (props) => {
  return (
    <div {...props} className={Utils.mergeClasses('info-view', props.className)}>
      {props.children}
    </div>
  );
};

export const InfoViewItem: FC<Props> = (props) => {
  return (
    <div
      className={Utils.mergeClasses('info-view-item', {
        'info-view-item-fullwidth': props.fullwidth,
      })}>
      <Title level={5}>{props.title}</Title>
      <div>{props.children}</div>
    </div>
  );
};
